import { useLanguage } from "../context/LanguageContext";
import { Brain, TrendingUp, Briefcase } from "lucide-react";

const iconMap = {
  Brain: Brain,
  TrendingUp: TrendingUp,
  Briefcase: Briefcase
};

const CompetenciesSection = ({ competencies }) => {
  const { language, t } = useLanguage();

  const getLocalizedText = (field) => {
    if (typeof field === 'string') return field;
    return language === 'no' ? field.no : field.en;
  };

  return (
    <section data-testid="competencies-section" className="py-16 md:py-24 border-t border-slate-200">
      <h2 className="text-3xl md:text-4xl font-semibold tracking-tight text-slate-800 mb-12 animate-fade-in-up">
        {t('Nøkkelkompetanse', 'Key Expertise')}
      </h2>

      {/* Bento Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {competencies.map((comp, index) => {
          const IconComponent = iconMap[comp.icon];
          return (
            <div
              key={index}
              data-testid={`competency-card-${index}`}
              className={`
                bg-white border border-slate-200 rounded-lg p-6 md:p-8
                hover:border-sky-400 hover:shadow-lg
                transition-all duration-300 ease-out
                animate-fade-in-up
                ${index === 0 ? 'md:col-span-2' : ''}
              `}
              style={{ animationDelay: `${(index + 1) * 100}ms` }}
            >
              <div className="flex items-center gap-3 mb-4">
                {IconComponent && (
                  <div className="w-10 h-10 rounded-lg bg-sky-50 flex items-center justify-center">
                    <IconComponent className="w-5 h-5 text-sky-600" />
                  </div>
                )}
                <h3 className="text-xl font-semibold text-slate-900">
                  {getLocalizedText(comp.title)}
                </h3>
              </div>
              <p className="text-slate-600 leading-relaxed">
                {getLocalizedText(comp.description)}
              </p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default CompetenciesSection;
